import React, { useState } from 'react';
import '../assets/css/catalog.css';
import CustomConfirm from '../helpers/CustomConfirm';
import { delete_stone_gallery_element } from '../firebase-communication/firebase-database';

const CatalogItem = ({ item, isAdmin, refreshCatalog }) => {
  const [overlayVisible, setOverlayVisible] = useState(false);

  if (!item || !item.img_url) return null;

  const handleDelete = (e, id, imgUrl) => {
    // prevent click‐through to the overlay toggle
    e.stopPropagation();
    CustomConfirm({
      message: 'Are you sure you want to delete this item?',
      onConfirm: async () => {
        try {
          await delete_stone_gallery_element(id, imgUrl);
          await refreshCatalog();
        } catch (error) {
          console.error('Failed to delete the item: ' + error.message);
        }
      },
      onCancel: () => console.log('Deletion cancelled.'),
    });
  };

  return (
    <div
      className="catalogItem"
      onClick={() => setOverlayVisible(v => !v)}
    >
      <img src={item.img_url} alt={item.title} className="catalogImage" />

      {/* Overlay */}
      <div
        className={`catalogOverlay ${overlayVisible ? 'show' : ''}`}
        onClick={e => {
          // clicking the overlay itself also closes it
          e.stopPropagation();
          setOverlayVisible(false);
        }}
      >
        <span className="overlayTitle">{item.title}</span>
      </div>

      {isAdmin && (
        <button
          className="deleteButton"
          onClick={e => handleDelete(e, item.id, item.img_url)}
        >
          X
        </button>
      )}
    </div>
  );
};

export default CatalogItem;